import { createFileRoute } from '@tanstack/react-router'
import OnboardingLayout from '@/pages/auth/onboarding/onboarding-layout'
import { PreferenceSelection } from '@/pages/auth/onboarding/components/preference-selection'
import { useOnboardingTracking } from '@/hooks/use-onboarding-tracking'

export const Route = createFileRoute('/(auth)/onboarding/preferences')({
  component: PreferencesPage,
})

function PreferencesPage() {
  const { track } = useOnboardingTracking()

  return (
    <OnboardingLayout currentStep={4} totalSteps={7}>
      <PreferenceSelection onAnalytics={track} />
    </OnboardingLayout>
  )
}